import { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { Spinner } from '../Spinner'

export interface ProtectedRouteProps {
  children: ReactNode
  redirectTo?: string
}

/**
 * ProtectedRoute - Wrapper component for authenticated routes
 * 
 * Redirects unauthenticated users to the auth screen.
 * Shows loading spinner while checking authentication status.
 * Used to protect routes that require authentication.
 * 
 * @example
 * <ProtectedRoute>
 *   <Dashboard />
 * </ProtectedRoute>
 */
export function ProtectedRoute({
  children,
  redirectTo = '/auth',
}: ProtectedRouteProps) {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <Spinner size="lg" />
      </div>
    )
  }

  if (!user) {
    return <Navigate to={redirectTo} replace />
  }

  return <>{children}</>
}
